import Skeleton from '@mui/material/Skeleton';
import { type TFunction } from 'i18next';
import { type ConfigFilter, type ConfigObject } from '../../../../_configs/types';
import RHFCheckbox from '../../../../components/hook-form/rhf-checkbox/component';
import RHFSelect from '../../../../components/hook-form/rhf-select/component';
import RHFSlider from '../../../../components/hook-form/rhf-slider/component';
import { type UseCarSearchReturn } from '../../../../hooks/use-car-search/types';
import checkUndefinedNullOrEmpty from '../../../../utils/tools/checkUndefinedNullOrEmpty';
import filterMap from '../maps/filterMap';

export default function getFilterElement(fKey: string, results: UseCarSearchReturn['results'], settings: ConfigObject, translate: TFunction, disableIcon: boolean, loading: boolean) {
    const filterElements = filterMap(settings?.general?.useFirmenFilter);
    const f = fKey.replace('[SM]', '').replace('[LG]', '') as ConfigFilter;
    const filterElement = filterElements?.[f];

    if (f === 'spacer') {
        return null;
    }

    if (loading === true && filterElement?.type !== 'aus') {
        return <Skeleton variant="rectangular" sx={{ height: 50, width: '100%' }} />;
    }

    return filterElement?.type === 'aus' ? (
        <div />
    ) : filterElement?.type === 'check' ? (
        <RHFCheckbox
            {...filterElement?.filterComponentProps}
            key={`filterElement_${filterElement?.type}_${filterElement?.filterKey}`}
            icon={disableIcon === true ? undefined : filterElement?.icon}
            disabled={settings?.general?.mockup}
            label={f === 'sofort' && !checkUndefinedNullOrEmpty(settings?.fahrzeugsuche?.customNameSofort) ? settings?.fahrzeugsuche?.customNameSofort : translate(`common:filter.${f}`)}
            name={filterElement?.filterKey}
            outlined
            uncheckIsNull
        />
    ) : filterElement?.type === 'singleselect' || filterElement?.type === 'multiselect' ? (
        <RHFSelect
            {...filterElement?.filterComponentProps}
            key={`filterElement_${filterElement?.type}_${filterElement?.filterKey}`}
            icon={disableIcon === true ? undefined : filterElement?.icon}
            disabled={settings?.general?.mockup}
            label={translate(`common:filter.${f}`)}
            name={filterElement?.filterKey}
            options={
                filterElement?.type === 'multiselect'
                    ? results?.facets?.[filterElement?.facetKey]
                    : [{ i: -100, t: translate('common:filter.alle') }, ...(results?.facets?.[filterElement?.facetKey] || [])]
            }
            placeholder={translate('common:filter.alle')}
            multiple={filterElement?.type === 'multiselect'}
        />
    ) : filterElement?.type === 'range' ? (
        <RHFSlider
            {...filterElement?.filterComponentProps}
            key={`filterElement_${filterElement?.type}_${filterElement?.filterKey}`}
            icon={disableIcon === true ? undefined : filterElement?.icon}
            id={filterElement?.filterKey}
            disabled={settings?.general?.mockup}
            label={translate(`common:filter.${f}`)}
            name={filterElement?.filterKey}
            options={results?.facets?.[filterElement?.facetKey]}
        />
    ) : (
        `unknown filter: ${f}`
    );
}
